import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MatDialogContent,
  MatDialogActions,
  MatDialogRef,
  MatDialogTitle,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { MatChipsModule } from '@angular/material/chips';

export interface ConfirmStatusDialogData {
  title: string;
  message: string;
  targetStatus: string;
}

@Component({
  selector: 'app-confirm-status-dialog',
  imports: [
    MatDialogContent,
    MatDialogTitle,
    MatDialogActions,
    MatButtonModule,
    MatIcon,
    MatChipsModule,
  ],
  templateUrl: './confirm-status-dialog.html',
  styleUrl: './confirm-status-dialog.scss',
})
export class ConfirmStatusDialog {
  readonly dialogRef = inject(MatDialogRef<ConfirmStatusDialog>);
  readonly data: ConfirmStatusDialogData = inject(MAT_DIALOG_DATA);

  confirm(): void {
    this.dialogRef.close(true);
  }

  cancel(): void {
    this.dialogRef.close(false);
  }
}

